import * as ko from 'knockout';
import * as $ from 'jquery';
import * as _ from 'underscore';

import { UserManager, UserTypes } from 'User/UserManager';

import { MenuAreasStore } from 'MenuManager/MenuAreas/Stores/MenuAreasStore';
import { MenuAreaModel } from 'MenuManager/MenuAreas/Models/MenuAreaModel';
import { JBoxDropDown } from 'Core/Components/JBoxDropdown/DropDown';
import { Event } from 'Core/Common/Event';

import { RecentAndFavorites } from 'Core/Components/RecentAndFavorites/RecentAndFavorites';
import { MenuQueries } from 'Core/Components/MenuQueries/MenuQueries';

import { DesignedScreenModel } from './Models/DesignedScreenModel';
import { TableModel } from './Models/TableModel';
import { BlockUI } from 'Core/Common/BlockUi';
import { LABELS } from 'Core/Components/Translation/Locales';
import { PUB_SUB_EVENTS } from 'MenuManager/PubSubEvents';
import { UserVarsManager } from 'Core/UserVarsManager/UserVarsManager';
import { MobileChecker } from 'Core/Common/MobileChecker';
import { Notifier } from '../../Core/Common/Notifier';

import MenuAreaTemplate from 'MenuManager/MenuAreas/Templates/MenuAreas.html';
ko.templates['MenuManager/MenuAreas/Templates/MenuAreas'] = MenuAreaTemplate;

import IconTemplate from 'MenuManager/MenuAreas/Templates/IconTemplate.html';
ko.templates['MenuManager/MenuAreas/Templates/IconTemplate'] = IconTemplate;

import FlyoutIconTemplate from 'MenuManager/MenuAreas/Templates/FlyoutIconTemplate.html';
ko.templates['MenuManager/MenuAreas/Templates/FlyoutIconTemplate'] = FlyoutIconTemplate;

import MenuAreasFlyoutTemplate from 'MenuManager/MenuAreas/Templates/MenuAreasFlyout.html';
ko.templates['MenuManager/MenuAreas/Templates/MenuAreasFlyout'] = MenuAreasFlyoutTemplate;

export class MenuAreas extends Event {
    private _showSearchButtons: KnockoutObservable<boolean>;
    private _areas: KnockoutObservableArray<MenuAreaModel>;
    private _selectedArea: MenuAreaModel;
    private _menuQueries: KnockoutObservable<MenuQueries>;
    private _menuQueriesTableId: KnockoutObservable<number>;
    private _recentAndFavorites: KnockoutObservable<RecentAndFavorites>;
    private _recentAndFavoritesTableId: KnockoutObservable<number>;
    private _rootScreen: KnockoutObservable<MenuAreaModel>;
    private _openedTableTypeFlowFolder: boolean;
    private _labels: LABELS;
    private _isMobile: KnockoutObservable<boolean>;

    // Flyout (collapsed sidebar)
    private _flyoutDropDown: JBoxDropDown;
    private _flyoutVm: any; // proxy vm $root (MenuManager)
    private _flyoutArea: KnockoutObservable<MenuAreaModel> = ko.observable(null);
    private _flyoutHideTimer: number;
    private _flyoutRootItem: KnockoutObservable<MenuAreaModel> = ko.observable(null);

    // UI state
    private _flyoutHoveredArea: KnockoutObservable<MenuAreaModel> = ko.observable(null);
    private _flyoutLockCount: number = 0;

    constructor() {
        super();

        this._showSearchButtons = ko.observable(false);
        this._areas = ko.observableArray([]);
        this._menuQueries = ko.observable(null);
        this._menuQueriesTableId = ko.observable(null);
        this._recentAndFavorites = ko.observable(null);
        this._recentAndFavoritesTableId = ko.observable(null);
        this._labels = LABELS;
        this._rootScreen = ko.observable(null);
        this._isMobile = ko.observable(MobileChecker.IsMobile());
    }

    DeleteAreas() {
        this._areas([]);
    }

    public GetAreaForScreen(screen: any): MenuAreaModel | null {
        if (!screen || !screen.Table || !screen.Table.Id) return null;

        return this.GetAreaByEntityId(screen.Table.Id);
    }

    public LockFlyout() {
        this._flyoutLockCount++;
    }

    public UnlockFlyout() {
        this._flyoutLockCount = Math.max(0, this._flyoutLockCount - 1);
    }

    public IsFlyoutLocked() {
        return this._flyoutLockCount > 0;
    }

    public SetFlyoutHovered(area: MenuAreaModel) {
        this._flyoutHoveredArea(area);
    }

    public ClearFlyoutHovered(item?: any) {
        if (item == null) return;

        if (this._flyoutHoveredArea() === item) {
            this._flyoutHoveredArea(null);
        }
    }

    public ClearFlyoutHoveredForce() {
        this._flyoutHoveredArea(null);
    }

    public GetFlyoutHovered() {
        return this._flyoutHoveredArea();
    }

    public CloseAllDropdowns() {
        // 0) stop pending close timer
        if (this._flyoutHideTimer) {
            window.clearTimeout(this._flyoutHideTimer);
            this._flyoutHideTimer = null;
        }

        // 1) close flyout
        this._flyoutArea?.(null);
        (this as any)._flyoutRootItem?.(null);
        this.ClearFlyoutHoveredForce?.();
        this._flyoutDropDown?.Close?.();

        // 2) close child dropdowns
        if (this._recentAndFavorites()) {
            this.DestroyRecentAndFavoritesDropdown();
            this._recentAndFavorites(null);
        }

        if (this._menuQueries()) {
            this.DestroyMenuQueriesDropdown();
            this._menuQueries(null);
        }

        // 3) remove UI classes
        $('.recent-and-favorites-active').removeClass('recent-and-favorites-active');
    }

    Init() {
        this.AddEvent('UPDATED');
    }

    Refresh(reloadScreen: boolean = true) {
        BlockUI.Block({ Target: $('#sidebar-menu')[0] });
        MenuAreasStore.Get()
            .always(() => {
                BlockUI.Unblock($('#sidebar-menu')[0]);
            })
            .fail((err) => {
                Notifier.Failed(err.message);
                this.Trigger('UPDATED', { ReloadScreen: reloadScreen });
            })
            .then((areasList) => {
                this._areas([]);
                _.forEach(areasList, (area) => {
                    if (area.Name !== 'Root') {
                        this._areas.push(area);
                    } else {
                        this._rootScreen(area);
                    }
                });

                this.Trigger('UPDATED', { ReloadScreen: reloadScreen });
            });
    }

    CollapseAll() {
        this._areas().forEach((area) => {
            area.IsActive(false);
            area.Screens.forEach((screen) => screen.IsSelected(false));
        });
    }

    GetTemplateName(): string {
        return 'MenuManager/MenuAreas/Templates/MenuAreas';
    }

    DestroyRecentAndFavoritesDropdown() {
        if (!this._isMobile()) {
            this._recentAndFavorites()?.DestroyRecentAndFavoritesDropdown();
        }

        if (this._recentAndFavorites()) {
            this._recentAndFavorites(null);
            this.UnlockFlyout();
        }
    }

    DestroyMenuQueriesDropdown() {
        if (!this._isMobile()) {
            this._menuQueries()?.DestroyMenuQueriesDropdown();
        }

        if (this._menuQueries()) {
            this._menuQueries(null);
            this.UnlockFlyout();
        }
    }

    AfterRender(elements?: any) {
        // Ensure flyout view model is created only once
        // and only when KO has rendered real DOM elements
        if (!this._flyoutVm && elements && elements.length) {
            // Get Knockout binding context from the first rendered element
            // This allows us to access the real $root (MenuManager instance)
            const ctx = ko.contextFor(elements[0]);
            const realRoot = ctx?.$root;

            // Create a proxy view model for the flyout
            // Prototype is the real $root, so all root methods/props are accessible
            this._flyoutVm = Object.create(realRoot || {});

            // --- Flyout-specific data ---
            // Root menu item used as flyout entry point
            this._flyoutVm._flyoutRootItem = this._flyoutRootItem;

            // Currently selected menu area (observable)
            this._flyoutVm._flyoutArea = this._flyoutArea;

            // --- Required observables from MenuAreas ---
            // These are read inside flyout templates
            this._flyoutVm._showSearchButtons = this._showSearchButtons;
            this._flyoutVm._isMobile = this._isMobile;
            this._flyoutVm._recentAndFavorites = this._recentAndFavorites;
            this._flyoutVm._recentAndFavoritesTableId = this._recentAndFavoritesTableId;
            this._flyoutVm._menuQueries = this._menuQueries;
            this._flyoutVm._menuQueriesTableId = this._menuQueriesTableId;

            // --- Critical part ---
            // Explicitly expose MenuAreas methods on $root
            // Without this, calls like $root.ShowQueriesDropdown will be undefined
            this._flyoutVm.ShowQueriesDropdown = this.ShowQueriesDropdown.bind(this);

            this._flyoutVm.ShowRecentAndFavoritesDropdown =
                this.ShowRecentAndFavoritesDropdown.bind(this);
        }
    }

    GetAreaByEntityId(entityId: number) {
        var value = null;
        _.each(this._areas(), (area) => {
            _.each(area.Screens, (screen) => {
                if (screen.Table.Id === entityId) {
                    value = area;
                }
            });
        });

        if (!value && this._rootScreen()) {
            _.each(this._rootScreen().Screens, (screen) => {
                if (screen.Table.Id === entityId) {
                    value = this._rootScreen();
                }
            });
        }

        return value;
    }

    GetScreenByEntityId(entityId: number): DesignedScreenModel {
        let value: DesignedScreenModel = null;
        _.each(this._areas(), (area) => {
            _.each(area.Screens, (screen) => {
                if (screen.Table.Id === entityId) {
                    value = screen;
                }
            });
        });

        if (!value && this._rootScreen()) {
            _.each(this._rootScreen().Screens, (screen) => {
                if (screen.Table.Id === entityId) {
                    value = screen;
                }
            });
        }
        return value;
    }

    get OpenedTypeFlowFolder() {
        return this._openedTableTypeFlowFolder;
    }

    set OpenedTypeFlowFolder(value: boolean) {
        this._openedTableTypeFlowFolder = value;
    }

    OpenSubMenu(menuAreaModel: MenuAreaModel) {
        const sidebarClosed = $('body').hasClass('page-sidebar-closed') && !this._isMobile();
        if (sidebarClosed) {
            return;
        }

        if (!this._selectedArea) {
            this._selectedArea = menuAreaModel;
            this._selectedArea.IsSelected(true);
        } else if (this._selectedArea !== menuAreaModel) {
            this._selectedArea.IsSelected(false);
            this._selectedArea = menuAreaModel;
            this._selectedArea.IsSelected(true);
        }
        if (this._menuQueries()) {
            this.DestroyMenuQueriesDropdown();
            // this._menuQueries(null);
        }
        if (this._recentAndFavorites()) {
            this.DestroyRecentAndFavoritesDropdown();
            // this._recentAndFavorites(null);
        }
    }

    SelectUser(entity, user) {
        UserVarsManager.Instance.AddRecent(entity.Id, user.Id, user.TypeId);

        PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, {
            EntityId: entity.Id,
            RecordId: user.Id,
            RecordTypeId: user.TypeId,
        });

        this.Trigger('RECORD_SELECTED');
    }

    ShowQueriesDropdown(entity: TableModel, screenModel: DesignedScreenModel, event) {
        let target: HTMLElement,
            isRecentAndFavoritesDropdownBox =
                $(event.target).parents('.recent-and-favorites-attach-to').length > 0;

        target = isRecentAndFavoritesDropdownBox
            ? $(event.target).parents('.recent-and-favorites-attach-to')[0]
            : event.currentTarget;

        const newTarget = $(target).closest('.subject-area').length
            ? $(target).closest('.subject-area')
            : target;
        const sidebar = $('.page-sidebar-menu');
        const sidebarClosed = sidebar.hasClass('page-sidebar-menu-closed');

        if (sidebarClosed) {
            $('.recent-and-favorites-active').removeClass('recent-and-favorites-active');
        }

        if (this._recentAndFavorites()) {
            this.DestroyRecentAndFavoritesDropdown();
            // this._recentAndFavorites(null);
        }

        if (this._menuQueries() && this._menuQueriesTableId() === entity.Id) {
            this.DestroyMenuQueriesDropdown();
            // this._menuQueries(null);

            return;
        }

        if (this._menuQueries() && this._menuQueriesTableId() !== entity.Id) {
            this.DestroyMenuQueriesDropdown();
            // this._menuQueries(null);
        }

        const menuQueries = new MenuQueries(entity.Id, target);

        // Lock flyout while child dropdown is open
        this.LockFlyout();

        menuQueries.On('QUERY_SELECTED', this, (eventArgs) => {
            this.CloseAllDropdowns();
            this.DestroyMenuQueriesDropdown();
            // this._menuQueries(null);

            if (sidebarClosed) {
                $(newTarget).removeClass('recent-and-favorites-active');
            }
        });

        this._menuQueries(menuQueries);
        this._menuQueriesTableId(entity.Id);

        $(window).resize(() => {
            if (this._menuQueries()) {
                this.DestroyMenuQueriesDropdown();
                // this._menuQueries(null);
            }
        });

        $(document).click((event) => {
            if (!$(event.target).closest('#menu-queries-panel').length) {
                if (this._menuQueries()) {
                    this.DestroyMenuQueriesDropdown();
                    // this._menuQueries(null);

                    if (sidebarClosed) {
                        $(target).removeClass('recent-and-favorites-active');
                    }
                }
            }
        });

        $('.page-sidebar-menu').scroll((event) => {
            if (this._menuQueries()) {
                this.DestroyMenuQueriesDropdown();
                // this._menuQueries(null);
            }
        });

        if (sidebarClosed) {
            $(newTarget).addClass('recent-and-favorites-active');

            $('.queries-dropdown').on('mouseleave.jBoxMenuQueries', (event) => {
                if (this._menuQueries()) {
                    this.DestroyMenuQueriesDropdown();
                    // this._menuQueries(null);
                    $(newTarget).removeClass('recent-and-favorites-active');
                    $('.queries-dropdown').off('mouseleave.jBoxMenuQueries');
                }
            });
        }
    }

    ShowRecentAndFavoritesDropdown(entity, data, event) {
        this._openedTableTypeFlowFolder = this.OpenedTypeFlowFolder;

        let target: HTMLElement,
            isRecentAndFavoritesDropdownBox =
                $(event.target).parents('.recent-and-favorites-attach-to').length > 0;

        target = isRecentAndFavoritesDropdownBox
            ? $(event.target).parents('.recent-and-favorites-attach-to')[0]
            : event.currentTarget;

        const newTarget = $(target).closest('.subject-area').length
            ? $(target).closest('.subject-area')
            : target;
        const sidebar = $('.page-sidebar-menu');
        const sidebarClosed = sidebar.hasClass('page-sidebar-menu-closed');

        if (sidebarClosed) {
            $('.recent-and-favorites-active').removeClass('recent-and-favorites-active');
        }

        if (this._menuQueries()) {
            this.DestroyMenuQueriesDropdown();
            // this._menuQueries(null);
        }

        if (this._recentAndFavorites() && this._recentAndFavoritesTableId() === entity.Id) {
            this.DestroyRecentAndFavoritesDropdown();
            // this._recentAndFavorites(null);

            return;
        }

        if (this._recentAndFavorites() && this._recentAndFavoritesTableId() !== entity.Id) {
            this.DestroyRecentAndFavoritesDropdown();
            // this._recentAndFavorites(null);
        }

        const recentAndFavorites = new RecentAndFavorites(
            entity,
            target,
            this._openedTableTypeFlowFolder
        );

        // Lock flyout while child dropdown is open
        this.LockFlyout();

        recentAndFavorites.On('RECORD_SELECTED', this, () => {
            // this.CloseAllDropdowns();
            this.DestroyRecentAndFavoritesDropdown();
            // this._recentAndFavorites(null);
            if (sidebarClosed) {
                $(newTarget).removeClass('recent-and-favorites-active');
            }
        });

        this._recentAndFavorites(recentAndFavorites);
        this._recentAndFavoritesTableId(entity.Id);

        $(window).resize(() => {
            if (this._recentAndFavorites()) {
                this.DestroyRecentAndFavoritesDropdown();
                // this._recentAndFavorites(null);
                // $(document).off('click');
            }
        });

        $(document).click((event) => {
            if (!$(event.target).closest('#recent-and-favorites-panel').length) {
                if (this._recentAndFavorites()) {
                    this.DestroyRecentAndFavoritesDropdown();
                    // this._recentAndFavorites(null);
                    // $(document).off('click');
                    if (sidebarClosed) {
                        $(newTarget).removeClass('recent-and-favorites-active');
                    }
                }
            }
        });

        $('.page-sidebar-menu').scroll((event) => {
            if (this._recentAndFavorites()) {
                this.DestroyRecentAndFavoritesDropdown();
                // this._recentAndFavorites(null);
            }
        });

        if (sidebarClosed) {
            $(newTarget).addClass('recent-and-favorites-active');

            $('.recent-and-favorites-dropdown').on('mouseleave.jBoxRecentAndFavorites', (event) => {
                if (this._recentAndFavorites()) {
                    this.DestroyRecentAndFavoritesDropdown();
                    // this._recentAndFavorites(null);
                    $(newTarget).removeClass('recent-and-favorites-active');
                    $('.recent-and-favorites-dropdown').off('mouseleave.jBoxRecentAndFavorites');
                }
            });
        }
    }

    ShowHideSearchButtons() {
        const userManager = UserManager.Instance;
        const addButtons =
            userManager.IsAuthenticated && userManager.CurrentUser.UserType !== UserTypes.Gdpr;
        this._showSearchButtons(addButtons);
    }
}
